module.exports = __webpack_public_path__ + "static/media/askuZ4.6a711bd4.png";